import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTraditionalRaffleList,
  fetchInstantWinList,
} from "./luckyDrawListing.action";

const initialState = {
  // Traditional Raffle
  traditionalRaffleList: [],
  traditionalRaffleTotalRecords: 0,
  traditionalRaffleFilteredRecords: 0,
  isFetchingTraditionalRaffle: false,
  traditionalRaffleError: null,

  // Instant Win
  instantWinList: [],
  instantWinTotalRecords: 0,
  instantWinFilteredRecords: 0,
  isFetchingInstantWin: false,
  instantWinError: null,

  // Shared filters
  activeTab: 0,
  filters: {
    search: "",
    product: [],
    startPeriodFrom: null,
    startPeriodTo: null,
    endPeriodFrom: null,
    endPeriodTo: null,
    progress: [],
  },
  page: 0,
  rowsPerPage: 25,
};

const luckyDrawListingSlice = createSlice({
  name: "luckyDrawListing",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
      state.page = 0;
    },
    setFilter: (state, action) => {
      const { field, value } = action.payload;
      state.filters[field] = value;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 0;
    },
    clearFilters: (state) => {
      state.filters = {
        search: "",
        product: [],
        startPeriodFrom: null,
        startPeriodTo: null,
        endPeriodFrom: null,
        endPeriodTo: null,
        progress: [],
      };
      state.page = 0;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
      state.page = 0;
    },
    resetListingState: () => initialState,
  },
  extraReducers: (builder) => {
    // Traditional Raffle List
    builder
      .addCase(fetchTraditionalRaffleList.pending, (state) => {
        state.isFetchingTraditionalRaffle = true;
        state.traditionalRaffleError = null;
      })
      .addCase(fetchTraditionalRaffleList.fulfilled, (state, action) => {
        state.isFetchingTraditionalRaffle = false;
        state.traditionalRaffleList = action.payload.lucky_draws || [];
        state.traditionalRaffleTotalRecords = action.payload.records_total || 0;
        state.traditionalRaffleFilteredRecords = action.payload.records_filtered || 0;
      })
      .addCase(fetchTraditionalRaffleList.rejected, (state, action) => {
        state.isFetchingTraditionalRaffle = false;
        state.traditionalRaffleError = action.payload;
      });

    // Instant Win List
    builder
      .addCase(fetchInstantWinList.pending, (state) => {
        state.isFetchingInstantWin = true;
        state.instantWinError = null;
      })
      .addCase(fetchInstantWinList.fulfilled, (state, action) => {
        state.isFetchingInstantWin = false;
        state.instantWinList = action.payload.lucky_draws || [];
        state.instantWinTotalRecords = action.payload.records_total || 0;
        state.instantWinFilteredRecords = action.payload.records_filtered || 0;
      })
      .addCase(fetchInstantWinList.rejected, (state, action) => {
        state.isFetchingInstantWin = false;
        state.instantWinError = action.payload;
      });
  },
});

export const {
  setActiveTab: setListingActiveTab,
  setFilter: setListingFilter,
  setFilters: setListingFilters,
  clearFilters: clearListingFilters,
  setPage: setListingPage,
  setRowsPerPage: setListingRowsPerPage,
  resetListingState,
} = luckyDrawListingSlice.actions;

export const luckyDrawListingReducer = luckyDrawListingSlice.reducer;
